interface IConfig {
  env: string;
  workflowUpdateInterval: number;
  endpoints: {
    csuApi: string;
    backofficeApi: string;
    osnova: string;
    logger: string;
    gcpApp: string;
    gcpRegistryApp: string;
    backofficeWebService: string;
    backofficeStorage: string;
    loginPage: string;
    loginService: string;
    braApi: string;
  };
  mapboxKey: string;
  hackForCreatingS3LinkForBws: {
    s3Endpoint: string;
    s3ExchangeBucket: string;
  };
  singleFileUpload: {
    partSizeBytes: number;
    requestTimeoutMs: number;
    maxRetries: number;
    retryIntervalMs: number;
    maxParallelRequests: number;
  };
  multipleFileUpload: {
    partSizeBytes: number;
    requestTimeoutMs: number;
    maxRetries: number;
    retryIntervalMs: number;
    maxParallelRequests: number;
    maxParallelFiles: number;
  };
  photoValidationOptions: {
    maxTimeToWaitAfterUploadMs: number;
    intervalToCheckPhotoValidationMs: number;
    maxTimeToWaitBeforeAutoUploadMs: number;
    intervalToCheckAutoUploadMs: number;
    checks: {
      distanceToSiteThresholdMeters: number;
      cameraGimbalDegreesMaxThreshold: number;
      minNumNonNadirToBeFailed: number;
      minPercentNonNadirToBeFailed: number;
      photoCreationTimeToNowRangeHours: number;
      blurScoreThreshold: number;
    };
  };
  fallbackGcpRequestEmail: string;
  tokenUpdateOvertakeFactor: number;
  putLogsToConsole: boolean;
  sendLogsInterval: number;
  performActionRetryTimeout: number;
  performActionRetryLimits: number;
  prescanOrthophotoLayerOptions: {
    tileSize: number;
    maxZoom: number;
    maxNativeZoom: number;
    zoomOffset: number;
  };
  pilotTutorialsLink: string;
  pilotInvoicePortalLink: string;
  jpegMetadataSizeBytes: number;
  pilotAppUrl: string;
  projectsAppUrl: string;
}

// This variable is defined in a separate script, that is generated
// by webpack and included in index.ejs
declare let config: IConfig;

export default config;
